import { useEffect, useState } from "react"
import { useAppSelector } from "../../../stateManagement/hooks/redux"
import SmallLoader from "../../loaders/SmallLoader"
import { notNullFilter } from "../../../features/dataFunctions/dataFunctions"
import { useFetchAxisLengthQuery, useLazyFetchRoadsQuery } from "../../../api/rtk/base/slices/pathsApiSlice"
import { getRoads } from "../../loginForm/loginFormFunctions"
import { highwayNetworkApiSlice } from "../../../api/rtk/base/slices/highwayNetworkApiSlice"

const roadsNumberIcon = require('../../../assets/images/icons/overallAnalytics/roadsNumberIcon.svg').default
const roadsLengthIcon = require('../../../assets/images/icons/overallAnalytics/roadsLengthIcon.svg').default
const highwayNetworkLengthIcon = require('../../../assets/images/icons/overallAnalytics/highwayNetworkLengthIcon.svg').default

export default function RoadsNumberAndLengthInfo() {

    const [roadsNumber, setRoadsNumber] = useState<any>(null)
    const [axisLength, setAxisLength] = useState<any>(null)
    const [highwayNetworkLength, setHighwayNetworkLength] = useState<any>(null)
    const { roadsList } = useAppSelector(state => state.pathsInfo)
    const { data: axisLengthData, isFetching: axisLengthDataIsFetching } = useFetchAxisLengthQuery({})
    const { data: highwayNetworkTotals, isFetching: highwayNetworkTotalsIsFetching } = highwayNetworkApiSlice.useFetchHighwayNetworkTotalsQuery({})
    const [fetchRoads, { isFetching: roadsListIsFetching }] = useLazyFetchRoadsQuery()

    useEffect(() => {
        if (roadsList) {
            const roadNames = roadsList.map((road: any) => road.Name).filter(notNullFilter)
            const roadsNumber = roadNames.length
            setRoadsNumber(roadsNumber)
        } else {
            initMissedRoads()
        }
    }, [roadsList])

    async function initMissedRoads() {
        await getRoads(fetchRoads)
    }

    useEffect(() => {
        if (axisLengthData) {
            const formattedAxisLength = axisLengthData?.Length?.toFixed(3)
            if (formattedAxisLength) setAxisLength(formattedAxisLength)
        }
    }, [axisLengthData])

    useEffect(() => {
        if (highwayNetworkTotals) {
            const highwayNetworkTotalsData = highwayNetworkTotals?.value[0]
            const highwayNetworkLength = highwayNetworkTotalsData?.LengthTotal
            if (highwayNetworkLength) setHighwayNetworkLength(highwayNetworkLength)
        }
    }, [highwayNetworkTotals])

    return (
        <div className="roads-number-and-length-info-div">
            <div className="roads-length">
                <div className="img-div">
                    <img src={roadsLengthIcon} />
                </div>
                <span>Общая протяжённость —
                    {axisLengthDataIsFetching
                        ?
                        <SmallLoader iconColor="black" />
                        :
                        <> {axisLength ? `${axisLength} км` : 'не указано'}</>
                    }
                </span>
            </div>
            <div className="highway-network-length">
                <div className="img-div">
                    <img src={highwayNetworkLengthIcon} />
                </div>
                <span>Опорная сеть дорог —
                    {highwayNetworkTotalsIsFetching
                        ?
                        <SmallLoader iconColor="black" />
                        :
                        <> {highwayNetworkLength ? `${highwayNetworkLength} км` : 'не указано'}</>
                    }
                </span>
            </div>
            <div className="roads-number">
                <div className="img-div">
                    <img src={roadsNumberIcon} />
                </div>
                <span>Количество дорог —
                    {roadsListIsFetching
                        ?
                        <SmallLoader iconColor="black" />
                        :
                        <> {roadsNumber ?? 'не указано'}</>
                    }
                </span>
            </div>
        </div>
    )
}
